import { INVOICE_TYPES, InvoiceType } from '@boltenergy-be/shared'
import { InvoiceTypeTranslationKey } from 'types/types.ts'

export const DEFAULT_ITEMS_PER_PAGE = 10

export const INVOICE_TYPE_TRANSLATION_KEYS: { [key in InvoiceType]: InvoiceTypeTranslationKey } = {
  [INVOICE_TYPES.instalment]: 'deposit',
  [INVOICE_TYPES.instalmentCreditnote]: 'deposit',
  [INVOICE_TYPES.settlement]: 'settlement',
  [INVOICE_TYPES.settlementCreditnote]: 'settlement',
  [INVOICE_TYPES.finalSettlement]: 'finalSettlement',
  [INVOICE_TYPES.finalSettlementCreditnote]: 'finalSettlement',
  [INVOICE_TYPES.finalSettlementInjection]: 'finalSettlementInjection',
  [INVOICE_TYPES.finalSettlementInjectionCreditnote]: 'finalSettlementInjection',
  [INVOICE_TYPES.injectionSettlementPro]: 'injectionSettlementPro',
  [INVOICE_TYPES.injectionSettlementProCreditnote]: 'injectionSettlementPro',
  [INVOICE_TYPES.injection]: 'injection',
  [INVOICE_TYPES.injectionCreditnote]: 'injection',
  [INVOICE_TYPES.injectionAnnulation]: 'injectionAnnulation',
  [INVOICE_TYPES.injectionAnnulationCreditnote]: 'injectionAnnulation',
  [INVOICE_TYPES.budgetMeter]: 'budgetMeter',
  [INVOICE_TYPES.budgetMeterCreditnote]: 'budgetMeter',
  [INVOICE_TYPES.rectification]: 'rectification',
  [INVOICE_TYPES.rectificationCreditnote]: 'rectification',
  [INVOICE_TYPES.rectificationInjection]: 'rectificationInjection',
  [INVOICE_TYPES.rectificationInjectionCreditnote]: 'rectificationInjection',
  [INVOICE_TYPES.cancel]: 'annulation',
  [INVOICE_TYPES.cancelCreditnote]: 'annulation',
  [INVOICE_TYPES.diverse]: 'additionalInvoice',
  [INVOICE_TYPES.diverseCreditnote]: 'additionalCompensation',
  [INVOICE_TYPES.manualCreditnote]: 'friendsDiscount',
  [INVOICE_TYPES.cashback]: 'cashback',
  [INVOICE_TYPES.purchaseInjection]: 'injection',
  [INVOICE_TYPES.purchaseInjectionCreditnote]: 'injection',
  [INVOICE_TYPES.purchaseInjectionPro]: 'injection',
  [INVOICE_TYPES.purchaseInjectionProCreditnote]: 'injection',
  [INVOICE_TYPES.miscInvoice]: 'miscellaneousInvoice',
  [INVOICE_TYPES.miscCreditnote]: 'miscellaneousCreditnote',

  // Excluded
  [INVOICE_TYPES.budgetMeterCounterBooking]: 'exclude',
  [INVOICE_TYPES.generalInternalFixBooking]: 'exclude',
  [INVOICE_TYPES.clientInternalFixBooking]: 'exclude',
  [INVOICE_TYPES.debtBookingPassThrough]: 'exclude',
  [INVOICE_TYPES.debtBookingHistoricSale]: 'exclude',
  [INVOICE_TYPES.debtBookingForwardFlow]: 'exclude'
} as const
